import { Component, OnInit, HostBinding, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Column, Locale } from '../datatable.models';
import { IDatatableAdvancedSearchEvent } from './datatable-advanced-seacher.type';

@Component({
	selector: 'rbc-datatable-advanced-searcher',
	templateUrl: './datatable-advanced-searcher.component.html',
	styleUrls: ['./datatable-advanced-searcher.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class DatatableAdvancedSearcherComponent implements OnInit {
	@HostBinding('class') @Input('class') classList: string = '';
	@Input() id: string;
	@Input() columnIndex: number;
	@Input() column: Column;
	@Input() locale: Locale;

	@Output('onadvancedsearchobjectupdate') onAdvancedSearchObjectUpdate = new EventEmitter<IDatatableAdvancedSearchEvent>();
	advancedSearchTerm = '';

	constructor() {}

	ngOnInit() {
		this.classList = [this.classList, 'datatable-advancedsearcher-wrapper'].filter(i => !!i).join(' ');
	}

	inputUpdate(newInput: string) {
		this.onAdvancedSearchObjectUpdate.emit({
			columnIndex: this.columnIndex,
			column: this.column,
			value: newInput
		});
	}

	reset() {
		this.advancedSearchTerm = '';
	}
}
